import React from 'react';
import { ArrowRightIcon, ZapIcon } from 'lucide-react';
import { SectionWrapper } from '../ui/SectionWrapper';
const pathways = ['Cognitive training', 'Recalibration pathways', 'Structured improvement', 'Measurable progress', 'Judgment development', 'Resilience building'];
export function DevelopmentalModel() {
  return <SectionWrapper hasDivider glowPosition="left" data-id="element-46">
      <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-47">
        <div data-id="element-48">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-teal-500/10 border border-teal-500/20 mb-6" data-id="element-49">
            <ZapIcon className="w-3 h-3 text-teal-400" data-id="element-50" />
            <span className="text-xs font-mono text-teal-300 uppercase tracking-widest" data-id="element-51">
              Continuous Evolution
            </span>
          </div>

          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-white mb-6" data-id="element-52">
            The state is designed to update, not stagnate
          </h2>

          <p className="text-lg text-slate-400 leading-relaxed mb-8" data-id="element-53">
            The purpose of the Cognarchic State is not merely to evaluate
            citizens and leaders, but to develop them. Individuals are not
            treated as permanently condemned categories. Those who show
            weaknesses in judgment, emotional stability, or resistance to
            manipulation are directed toward structured training, recalibration,
            and cognitive development pathways designed to produce measurable
            improvement over time.
          </p>
        </div>

        <div className="relative" data-id="element-54">
          {/* Decorative connecting lines behind pills */}
          <div className="absolute top-1/2 left-10 right-10 h-px bg-gradient-to-r from-transparent via-cyan-500/20 to-transparent -translate-y-1/2 hidden md:block" data-id="element-55" />
          <div className="absolute top-10 bottom-10 left-1/2 w-px bg-gradient-to-b from-transparent via-cyan-500/20 to-transparent -translate-x-1/2 hidden md:block" data-id="element-56" />

          <div className="flex flex-wrap gap-4 justify-center relative z-10" data-id="element-57">
            {pathways.map((path, idx) => <div key={idx} className="flex items-center gap-2" data-id="element-58">
                <div className="bg-[#060a14]/80 backdrop-blur-md border border-cyan-500/20 rounded-full px-6 py-3 text-cyan-300 text-sm font-medium shadow-[0_0_15px_-3px_rgba(34,211,238,0.1)] hover:border-cyan-400/50 hover:shadow-[0_0_20px_-3px_rgba(34,211,238,0.3)] transition-all cursor-default" data-id="element-59">
                  {path}
                </div>
                {idx !== pathways.length - 1 && idx % 2 === 0 && <ArrowRightIcon className="w-4 h-4 text-slate-600 hidden md:block" data-id="element-60" />}
              </div>)}
          </div>
        </div>
      </div>
    </SectionWrapper>;
}